import { companies } from './companies';
import { regalxAccountSubtypes } from './account';
import { generateKeys } from '../utils';
import { mt4Servers } from './forexServers';
import { map } from 'lodash';
import { DateFormat } from './dateFormats';
const getApplicableSubtypes = (subtypes) => {
    return map(subtypes, (subtype) => subtype);
};
export const whiteLabels = generateKeys({
    accuracyAccounts: {
        value: 'accuracyAccounts',
        domain: 'accuracyaccounts.com',
        company: companies.swissMarkets,
        label: 'Accuracy Accounts',
        disableMarketingCommunications: true,
        ignoreALA: true,
        category: 'accuracyAccounts',
        sendGridTemplate: 'accuracy-generic',
        portalDomain: 'dashboard-accuracyaccounts-eu.swissmarkets.com',
        allowEmails: true,
        mt4Servers: [
            mt4Servers.real01.value,
        ],
        excludeEmailTemplates: ['welcomeEmail'],
    },
    bdxAccounts: {
        value: 'bdxAccounts',
        domain: 'bdxalliance.com',
        company: companies.bdSwissMauritius,
        label: 'BDX Accounts',
        disableMarketingCommunications: true,
        ignoreALA: true,
        disabled: true,
        category: 'bdxAccounts',
        excludeEmailTemplates: ['welcomeEmail'],
    },
    accuracyAccountsMauritius: {
        value: 'accuracyAccountsMauritius',
        domain: 'accuracyaccounts.com',
        company: companies.swissMarketsMauritius,
        label: 'Accuracy Accounts',
        disableMarketingCommunications: true,
        ignoreALA: true,
        category: 'accuracyAccounts',
        sendGridTemplate: 'accuracy-generic',
        portalDomain: 'dashboard-accuracyaccounts.swissmarkets.com',
        allowEmails: true,
        mt4Servers: [
            mt4Servers.real01.value,
        ],
        excludeEmailTemplates: ['welcomeEmail'],
    },
    regalx: {
        value: 'regalx',
        domain: 'regalx.com',
        company: companies.bdSwiss,
        label: 'Regalx',
        disableMarketingCommunications: true,
        ignoreALA: true,
        category: 'regalx',
        sendGridTemplate: 'regalx-generic',
        portalDomain: 'dashboard-relgalx-eu.bdswiss.com',
        allowEmails: true,
        mt4Servers: [
            mt4Servers.real01.value,
        ],
        baseProducts: ['ForexAccount', 'ForexDemoAccount'],
        supportedSubtypes: getApplicableSubtypes(regalxAccountSubtypes),
        excludeEmailTemplates: ['welcomeEmail'],
    },
    regalxMauritius: {
        value: 'regalxMauritius',
        domain: 'regalx.com',
        company: companies.bdSwissMauritius,
        label: 'Regalx',
        disableMarketingCommunications: true,
        ignoreALA: true,
        category: 'regalx',
        sendGridTemplate: 'regalx-generic',
        portalDomain: 'dashboard-regalx.bdswiss.com',
        allowEmails: true,
        mt4Servers: [
            mt4Servers.real03.value,
            mt4Servers.real04.value,
        ],
        baseProducts: ['ForexMauritiusAccount', 'ForexMauritiusDemoAccount'],
        supportedSubtypes: getApplicableSubtypes(regalxAccountSubtypes),
        excludeEmailTemplates: ['welcomeEmail'],
    },
    regalxVanuatu: {
        value: 'regalxVanuatu',
        domain: 'regalx.com',
        company: companies.bdSwissVanuatu,
        label: 'Regalx',
        disableMarketingCommunications: true,
        ignoreALA: true,
        category: 'regalx',
        sendGridTemplate: 'regalx-generic',
        portalDomain: 'dashboard-regalx-global.bdswiss.com',
        allowEmails: true,
        mt4Servers: [
            mt4Servers.real03.value,
            mt4Servers.real04.value,
        ],
        baseProducts: ['ForexVanuatuAccount', 'ForexVanuatuDemoAccount'],
        supportedSubtypes: getApplicableSubtypes(regalxAccountSubtypes),
        excludeEmailTemplates: ['welcomeEmail'],
    },
    bdsTrading: {
        value: 'bdsTrading',
        domain: 'eu.bdstrading.com',
        company: companies.bdSwiss,
        label: 'BDSTrading',
        disableMarketingCommunications: false,
        ignoreALA: false,
        category: 'bdsTrading',
        sendGridTemplate: 'bdstrading-generic',
        portalDomain: 'dashboard-eu.bdstrading.com',
        allowEmails: true,
        internal: true,
        emailDomain: 'bdstrading.com',
        baseProducts: ['ForexAccount', 'ForexDemoAccount', 'ForexMT5Account'],
        terminationPopup: {
            suppressPopupDate: '31/10/2023',
            dateFormat: DateFormat.ddmmyyyySlash,
            migratedBrandLabel: companies.bdSwiss.brandLabel,
            migratedTradingName: companies.bdSwiss.tradingName,
        },
    },
    bdsTradingMauritius: {
        value: 'bdsTradingMauritius',
        domain: 'bdstrading.com',
        company: companies.bdSwissMauritius,
        label: 'BDSTrading',
        disableMarketingCommunications: false,
        ignoreALA: false,
        category: 'bdsTrading',
        sendGridTemplate: 'bdstrading-generic',
        portalDomain: 'dashboard.bdstrading.com',
        allowEmails: true,
        internal: true,
        emailDomain: 'bdstrading.com',
        baseProducts: ['ForexMauritiusAccount', 'ForexMauritiusDemoAccount', 'ForexMT5MauritiusAccount'],
        terminationPopup: {
            suppressPopupDate: '31/10/2023',
            dateFormat: DateFormat.ddmmyyyySlash,
            migratedBrandLabel: companies.bdSwissMauritius.brandLabel,
            migratedTradingName: companies.bdSwissMauritius.tradingName,
        },
    },
    bdsTradingVanuatu: {
        value: 'bdsTradingVanuatu',
        domain: 'global.bdstrading.com',
        company: companies.bdSwissVanuatu,
        label: 'BDSTrading',
        disableMarketingCommunications: false,
        ignoreALA: false,
        category: 'bdsTrading',
        sendGridTemplate: 'bdstrading-generic',
        portalDomain: 'dashboard-global.bdstrading.com',
        allowEmails: true,
        internal: true,
        emailDomain: 'bdstrading.com',
        baseProducts: ['ForexVanuatuAccount', 'ForexVanuatuDemoAccount', 'ForexMT5VanuatuAccount',
            'AffiliateVanuatuAccount', 'IntroducingBrokerBDSwissVanuatuAccount'],
        terminationPopup: {
            suppressPopupDate: '31/10/2023',
            dateFormat: DateFormat.ddmmyyyySlash,
            migratedBrandLabel: companies.bdSwissVanuatu.brandLabel,
            migratedTradingName: companies.bdSwissVanuatu.tradingName,
        },
    },
});
